var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSkull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.1644V18.32C1 20.4659 2.73957 22.2055 4.88543 22.2055C5.10002 22.2055 5.27397 22.3794 5.27397 22.594V22.9909C5.27397 26.4609 8.08701 29.274 11.5571 29.274H14.4429C17.913 29.274 20.726 26.4609 20.726 22.9909V22.594C20.726 22.3794 20.9 22.2055 21.1146 22.2055C23.2604 22.2055 25 20.4659 25 18.32V13.1644C25 7.73973 21.5479 1 12.8356 1C4.12329 1 1 8.23288 1 13.1644Z",
    stroke: "#323844",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7305 24.95C10.7305 24.5357 10.3947 24.2 9.98047 24.2C9.56626 24.2 9.23047 24.5357 9.23047 24.95H10.7305ZM9.98047 28.8952H9.23047V29.6452H9.98047V28.8952ZM15.8983 28.8952V29.6452H16.6483V28.8952H15.8983ZM16.6483 24.95C16.6483 24.5357 16.3125 24.2 15.8983 24.2C15.4841 24.2 15.1483 24.5357 15.1483 24.95H16.6483ZM13.6894 24.95C13.6894 24.5357 13.3536 24.2 12.9394 24.2C12.5252 24.2 12.1894 24.5357 12.1894 24.95H13.6894ZM9.23047 24.95V28.8952H10.7305V24.95H9.23047ZM16.6483 28.8952V24.95H15.1483V28.8952H16.6483ZM9.98047 29.6452H12.9394V28.1452H9.98047V29.6452ZM12.9394 29.6452H15.8983V28.1452H12.9394V29.6452ZM13.6894 28.8952V24.95H12.1894V28.8952H13.6894Z",
    fill: "#323844"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.421 14.3538C11.3221 15.8706 10.1235 17.0172 8.72549 17.0172C7.26569 17.0172 6.02344 15.7671 6.02344 14.1507C6.02344 12.6078 7.15546 11.3986 8.52812 11.2919C9.51447 11.9062 10.3779 12.6943 11.421 14.3538Z",
    stroke: "#323844",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6476 14.1507C19.6476 15.8027 18.4458 17.0172 17.1099 17.0172C15.8233 17.0172 14.661 15.8905 14.5771 14.3314C15.0081 13.5425 15.3863 12.9723 15.8065 12.5047C16.2122 12.0531 16.6761 11.6759 17.3028 11.2927C18.5593 11.4028 19.6476 12.5787 19.6476 14.1507Z",
    stroke: "#323844",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7404 18.7613C12.2071 17.8631 13.4921 17.8631 13.9588 18.7612L14.5628 19.9236C14.9952 20.7558 14.3914 21.75 13.4536 21.75H12.2456C11.3079 21.75 10.704 20.7558 11.1364 19.9236L11.7404 18.7613Z",
    stroke: "#323844",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkull);
export default __webpack_public_path__ + "static/media/Skull.534b382267484e1e0638fa5079c88805.svg";
export { ForwardRef as ReactComponent };